import React from 'react';
import {Card} from "react-bootstrap";

const Footer = () => {
    return (
       <Card bg={"dark"} text={'white'}>
           <footer className='p-4 d-flex justify-content-between align-items-center'>
               <h2>English Premier League</h2>
               <h3>All rights reserved</h3>
           </footer>
       </Card>
    );
};

export default Footer;